import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { applyBreakpoints, md } from '../../utils/breakpoints';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';

const styles = {
  exclamationPoint: RX.Styles.createTextStyle({
    color: colors.alert,
    fontSize: 100,
    fontWeight: '500',
  }),
  yellowCircle: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.yellow,
    borderRadius: 100,
    height: 100,
    justifyContent: 'center',
    width: 100,
  })
};

export class YellowExclamation extends RX.Component<{window: Window, smallHide?: boolean}, RX.Stateless> {

  constructor(props) {
    super(props);
  }

  public render() {
    const { window: { width }, smallHide} = this.props;

    return (
      !smallHide || width >= md ? <RX.View style={styles.yellowCircle}>
        <RX.Text style={styles.exclamationPoint}>!</RX.Text>
      </RX.View> : null
    );
  }
}

export default connect(mapStateToProps)(YellowExclamation);



// WEBPACK FOOTER //
// ./src/components/yellow_exclamation/index.tsx